import { t } from "@superset-ui/core";
import { LabelPosition, LabelAlignment } from "./enums";

export default function validateForTwo(v: unknown) {
  if (Array.isArray(v) && v.length !== 2) {
    return t('need two category columns.');
  }
  return false;
}

export const commonControlsConfig = {
  labelPosition: {
    type: 'SelectControl',
    label: 'Label Position',
    choices: [
      [LabelPosition.Inner, 'Inner'],
      [LabelPosition.Outer, 'Outer'],
    ],
    renderTrigger: true,
  },
  labelAlignment: {
    type: 'SelectControl',
    label: 'Label Alignment',
    choices: [
      [LabelAlignment.None, 'None'],
      [LabelAlignment.LabelLine, 'Label Line'],
      [LabelAlignment.Edge, 'Edge']
    ],
    renderTrigger: true,
  },
  tooltipFormat: {
    type: 'TextControl',
    label: t('Tooltip Format'),
    description: t(
      'String template for tooltip format. Ex: {a} <br/>{b}: {c} ({d}%).' +
      '{a} for series name, {b} for data item name, {c} for data value, {d} for percentage.'
    ),
    renderTrigger: true,
  },
  labelFormat: {
    type: 'TextControl',
    label: t('Label Format'),
    description: t(
      'String template for tooltip format. Ex: {a} <br/>{b}: {c} ({d}%).\n' +
      '{a} for series name, {b} for data item name, {c} for data value, {d} for percentage.'
    ),
    renderTrigger: true,
  },
  richStyle: {
    type: 'TextControl',
    label: t('Rich Style Json'),
    description: t(
      'A Stringified JSON with class names for keys and objects with css properties.\n' +
      'Ex: {"a": {"color": "#6E7079","lineHeight": 22,"align": "center","borderColor": "#8C8D8E"}}"'
    ),
    renderTrigger: true,
  },
  image: {
    type: 'TextControl',
    label: t('Image'),
    description: t(
      'Image as a Base64 encoded data url string.',
    ),
    renderTrigger: true,
  }
};
